import React, { useEffect, useState, useCallback } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Check, Loader2, Clock } from 'lucide-react';
import { API } from '../config/api';

export default function MandatSigne() {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState('loading');
  const [tries, setTries] = useState(0);

  const poll = useCallback(async () => {
    if (!sessionId) { setStatus('error'); return; }
    try {
      const res = await axios.get(`${API}/subscriptions/status/${sessionId}`);
      if (res.data.status === 'mandat_signe') setStatus('signed');
      else if (tries >= 6) setStatus('pending');
      else setTries((t) => t + 1);
    } catch (e) {
      if (tries >= 6) setStatus('error'); else setTries((t) => t + 1);
    }
  }, [sessionId, tries]);

  useEffect(() => {
    if (status === 'loading' || status === 'polling') {
      const id = setTimeout(poll, tries === 0 ? 400 : 1800);
      return () => clearTimeout(id);
    }
  }, [poll, tries, status]);

  return (
    <div className="min-h-screen bg-[#F5EFE5] flex items-center justify-center px-4" data-testid="mandat-signe-page">
      <Card className="bg-white border-[#E9DDCC] rounded-3xl max-w-md w-full">
        <CardContent className="p-8 text-center space-y-4">
          {status === 'loading' && (
            <><Loader2 className="w-8 h-8 animate-spin text-[#C99A55] mx-auto" />
              <h1 className="font-heading text-xl text-[#493329]">Enregistrement de votre mandat…</h1></>
          )}
          {status === 'signed' && (
            <><div className="w-14 h-14 rounded-full bg-[#C99A55]/15 flex items-center justify-center mx-auto"><Check className="w-7 h-7 text-[#C99A55]" strokeWidth={2} /></div>
              <h1 className="font-heading text-xl text-[#493329]" data-testid="mandat-signed-title">Mandat signé avec succès</h1>
              <p className="text-sm text-[#7A6455]">Merci ! Votre mandat de prélèvement SEPA est enregistré. <strong>Aucun prélèvement</strong> ne sera effectué avant la date d'ouverture fixée par le studio — vous serez prévenue avant le premier prélèvement.</p></>
          )}
          {status === 'pending' && (
            <><Clock className="w-8 h-8 text-[#C99A55] mx-auto" />
              <h1 className="font-heading text-xl text-[#493329]">Mandat en cours de validation</h1>
              <p className="text-sm text-[#7A6455]">Votre mandat est en cours d'enregistrement auprès de votre banque. Le statut se mettra à jour sous peu dans votre espace.</p></>
          )}
          {status === 'error' && (
            <><h1 className="font-heading text-xl text-[#493329]">Statut indisponible</h1>
              <p className="text-sm text-[#7A6455]">Nous n'avons pas pu confirmer la signature. Vérifiez votre espace abonnement ou réessayez.</p></>
          )}
          <Link to="/abonnement"><Button className="rounded-full bg-[#C99A55] hover:bg-[#493329] text-white" data-testid="mandat-back-btn">Retour à mon abonnement</Button></Link>
        </CardContent>
      </Card>
    </div>
  );
}
